import { create } from 'zustand'
import moment, { Moment } from 'moment';

interface DealBuilderRealTimeAAAStore {
  lastFetchDate: Moment,
  realTimeAAA: number[],
  setRealTimeAAA: (realTimeAAA: number[]) => void,
}

const DEFAULT_LAST_FETCH = moment("2000-01-01");

const useDealBuilderRealTimeAAAStore = create<DealBuilderRealTimeAAAStore>((set) => ({
  realTimeAAA: [],
  setRealTimeAAA: (realTimeAAA: number[]) => set({ realTimeAAA, lastFetchDate: moment() }),
  lastFetchDate: DEFAULT_LAST_FETCH
}));

export default useDealBuilderRealTimeAAAStore;
